export enum EnSerialMsg {
  valid = 'Serial válido',
  invalid = 'O serial digitado é inválido. Gentileza conferir os números. Cuidado com letras maiúsculas e minúsculas.',
  used = 'Desculpe, mas esse serial já foi utilizado!',
}
